/**
 * ============================================================
 *  环境配置（全局唯一入口）
 * ============================================================
 *  上线/切环境只需修改下面的 DEFAULT_ENV 一处即可，
 *  所有接口域名（api/http.js、utils/http.js、utils/util.js、utils/api.js）
 *  都会自动跟随切换，不要再在各个文件里单独写域名！
 *
 *  可选值：
 *    'test' —— 测试环境
 *    'pre'  —— 预发环境
 *    'prd'  —— 正式环境
 *
 *  小技巧：浏览器地址栏加 ?env=test|pre|prd 参数可临时覆盖环境，
 *  方便测试时不用重新打包（不带参数时以 DEFAULT_ENV 为准）。
 * ============================================================
 */
const DEFAULT_ENV = 'prd';

const configs = {
    // 测试环境
    test: {
        api: 'https://v3api-test3.klcxkj-qzxy.cn',                       // 主接口
        apiGuardian: 'https://v3api-guardian-test3.klcxkj-qzxy.cn',      // 账单接口
        apiManage: 'https://v3api-manage-test3.klcxkj-qzxy.cn',          // 管理端接口
        cas: 'https://lbxzx-test.china-qzxy.cn/campus_cas/validate',     // CAS 校验
        xc: 'https://xc.klcxkj-qzxy.cn',                                 // 校园卡/行程接口
        kh: 'https://dev.cskaihe.com/api',                               // 开和水接口
        ticket: 'https://app-cold-water.klcxkj-qzxy.cn/',                // 票据/页面跳转 host
        prepay: 'https://prepay.china-qzxy.cn',                          // 预支付接口
    },
    // 预发环境（没有预发地址的服务沿用正式环境地址）
    pre: {
        api: 'https://dev-v3-api.china-qzxy.cn',
        apiGuardian: 'https://v3-pre-guardian-api.china-qzxy.cn',
        apiManage: 'https://v3-pre-manage-api.china-qzxy.cn',
        prepay: 'https://prepay.china-qzxy.cn',  
        ticket: 'https://app-cold-water.china-qzxy.cn/', 
        cas: 'https://campuspay.china-qzxy.cn/cas/validate',
        xc: 'https://qzhqapi.china-qzxy.cn',
        kh: 'https://pord.cskaihe.com/api',
    },
    // 正式环境
    prd: {
        api: 'https://v3-api.china-qzxy.cn',
        apiGuardian: 'https://v3-guardian-api.china-qzxy.cn',
        apiManage: 'https://v3-manage-api.china-qzxy.cn',
        cas: 'https://campuspay.china-qzxy.cn/cas/validate',
        xc: 'https://qzhqapi.china-qzxy.cn',
        kh: 'https://pord.cskaihe.com/api',
        ticket: 'https://app-cold-water.china-qzxy.cn/',
        prepay: 'https://prepay.china-qzxy.cn',
    },
};

// 支持 URL 参数 ?env=xxx 临时覆盖环境
function getEnvFromUrl() {
    try {
        const match = window.location.search.match(/[?&]env=(test|pre|prd)\b/);
        return match ? match[1] : null;
    } catch (e) {
        return null;
    }
}

const ENV = getEnvFromUrl() || DEFAULT_ENV;

// 合并配置：缺失项自动回退到正式环境地址，避免预发漏配导致 undefined
const envConfig = { ...configs.prd, ...(configs[ENV] || {}) };

console.info(`[env] 当前环境：${ENV}`, envConfig);

export const ENV_NAME = ENV;
export default envConfig;
